import getAuthPortalRedirectUrl from '../../helpers/getAuthPortalRedirectUrl';
export default function RedirectToAuth() {
  window.location.assign(getAuthPortalRedirectUrl());
  return null;
}